import store from '@/store'
import {
  PATH_NAME_BOARD,
  PATH_NAME_BOARD_DETAIL_VIEW,
  PATH_NAME_EVENT,
  PATH_NAME_EVENT_DETAIL,
  PATH_NAME_EVENT_EMERGENCY,
  PATH_NAME_EVENT_LIST,
} from '@/common/router.const'

export default [
  {
    path: '/event',
    name: PATH_NAME_EVENT,
    components: {
      event: () => import('@/views/event/EventView'),
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.getBeforePathOpenMyPooq === '') {
        store.commit('setBeforePathOpenMyPooq', from.fullPath)
      }
      if (to.path.indexOf('.html') > -1) {
        next(to.path.replace('.html', ''))
      }
      next()
    },
    children: [
      {
        path: 'list',
        name: PATH_NAME_EVENT_LIST,
        components: {
          eventlist: () => import('@/components/lnb/event/EventList'),
        },
      },
      {
        path: 'detail/:eventid',
        name: PATH_NAME_EVENT_DETAIL,
        components: {
          eventdetail: () => import('@/components/lnb/event/EventDetailView'),
        },
      },
      {
        path: 'board',
        name: PATH_NAME_BOARD,
        components: {
          boardlist: () => import('@/components/lnb/event/EventBoardList'),
        },
      },
      {
        path: 'board/:eventid',
        name: PATH_NAME_BOARD_DETAIL_VIEW,
        components: {
          boarddetail: () => import('@/components/lnb/event/BoardContent'),
        },
      },
    ],
  },
  {
    path: '/event/index',
    name: PATH_NAME_EVENT_EMERGENCY,
    alias: '/event/index.html',
    components: {
      event_emergency: () => import('@/components/event/index'),
    },
  },
]
